"use strict";
// (C) 2007-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCssToStylesheet = void 0;
var domUtilities_1 = require("../utils/domUtilities");
/**
 * Appends CSS rules to existing stylesheet or creates it and appends to DOM first, if it does not exists.
 *
 * @param sheetId - ID of the stylesheet (<style> element in the DOM document).
 * @param rules - string with stylesheet rules, for example `html {border: 3px dotted black; padding: 20px;}`.
 * @param clear - true if stylesheet identified by 'sheetId' id should be removed from DOM if it is found, false if 'rules' should be appended to it.
 * @returns updated stylesheet
 *
 * @internal
 */
function addCssToStylesheet(sheetId, rules, clear) {
    if (clear === void 0) { clear = false; }
    var stylesNode = document.createTextNode(rules);
    var exStyleSheet = document.getElementById(sheetId);
    // clear stylesheet
    if (clear && exStyleSheet) {
        domUtilities_1.removeFromDom(exStyleSheet);
        exStyleSheet = null;
    }
    // stylesheet already exist - we just append the rules
    if (exStyleSheet) {
        exStyleSheet.appendChild(stylesNode);
        return exStyleSheet;
    }
    // create new stylesheet and append the rules
    var styleElement = document.createElement("style");
    styleElement.id = sheetId;
    styleElement.type = "text/css";
    styleElement.appendChild(stylesNode);
    // append the styleSheet into DOM
    document.getElementsByTagName("head")[0].appendChild(styleElement);
    return styleElement;
}
exports.addCssToStylesheet = addCssToStylesheet;
//# sourceMappingURL=addCssToStylesheet.js.map